import { Link, useNavigate } from "react-router-dom";
import { Header } from "../components/Header";
import { Breadcrumbs, PublicFooter } from "../components/PublicChrome";
import { useSeo, breadcrumbs, ORGANIZATION } from "../lib/seo";
import { GAA_PAGES, RUGBY_PAGES, pagePath } from "../lib/regionPages";
import { countyBadgeUrl, provinceBadgeUrl } from "../lib/regions";

const CRUMBS = [["Home", "/"], ["Counties & provinces", "/counties"]];
const DESC = "Personalised GAA player cards & shields for all 32 counties and overseas GAA, plus rugby shields for Munster, Leinster, Ulster and Connacht.";

const Tile = ({ p, src }) => (
  <Link to={pagePath(p)} className="card-lift flex items-center gap-3 border-2 border-slate-200 bg-white p-3 hover:border-slate-900" data-testid={`counties-link-${p.sport}-${p.slug}`}>
    <img src={src} alt="" className="h-8 w-12 shrink-0 border border-slate-200 object-cover" />
    <span className="min-w-0"><span className="block truncate font-bold">{p.name}</span><span className="block truncate text-xs text-slate-500">{p.nick}</span></span>
  </Link>
);

export default function Counties({ missing }) {
  const nav = useNavigate();
  useSeo(missing ? { title: "Page not found | sportsshields.ie", description: "Page not found.", noindex: true }
    : { title: "GAA County & Rugby Province Shields | sportsshields.ie", description: DESC, path: "/counties", jsonLd: { "@context": "https://schema.org", "@graph": [ORGANIZATION, breadcrumbs(CRUMBS)] } });
  return (
    <div className="min-h-screen">
      <Header onNew={() => nav("/design")} />
      <main className="mx-auto max-w-6xl px-4 py-8 sm:px-6 lg:py-12">
        <Breadcrumbs items={CRUMBS} />
        {missing && <p className="mt-4 border-2 border-amber-400 bg-amber-50 p-3 text-sm font-semibold" data-testid="counties-missing">We couldn't find that page – pick your county or province below.</p>}
        <h1 className="font-display mt-4 text-4xl font-black uppercase leading-none tracking-tight sm:text-5xl" data-testid="counties-title">County & province shields</h1>
        <p className="mt-4 max-w-2xl text-slate-600">{DESC}</p>
        {!missing && (
          <div className="mt-4 max-w-2xl space-y-3 text-slate-600" data-testid="counties-intro">
            <p>Every county and province page has its own colours, crest and ideas, so your shield looks right for the jersey your player wears. Pick a county to see shields in its colours. You can change any detail in the designer before you order, including the name, number, position, photo and stats.</p>
            <p>Clubs can order a whole squad together. The coach shares one link, each parent adds their child's photo and pays, and we print and post the full set. Every shield is printed by Business Print in Dublin on rigid board, cut to the shield shape, and ready to hang on a bedroom wall.</p>
          </div>
        )}
        <h2 className="font-display mt-10 text-2xl font-black uppercase">GAA counties</h2>
        <div className="mt-4 grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-4">{GAA_PAGES.map((p) => <Tile key={p.id} p={p} src={countyBadgeUrl(p.id)} />)}</div>
        <h2 className="font-display mt-10 text-2xl font-black uppercase">Rugby provinces</h2>
        <div className="mt-4 grid grid-cols-2 gap-2 sm:grid-cols-4">{RUGBY_PAGES.map((p) => <Tile key={p.id} p={p} src={provinceBadgeUrl(p.id)} />)}</div>
      </main>
      <PublicFooter />
    </div>
  );
}
